import { ReactComponent as Close } from "../../assets/x.svg";
import Button from "../Button/Button";
import "./ConfirmationModal.scss";

export default function ConfirmationModal({
  title,
  variant = "danger", // ou primary (azul)
  message,
  onCancel,
  onConfirm,
  secText,
  varText,
}) {
  return (
    <div id="confirmation-modal-backdrop">
      <div className="confirmation-modal">
        <div className="modal-header">
          <h4>{title}</h4>
        </div>
        <div className="modal-body">
          <div className={`confirmation-message ${variant}`}>
            <p>{message}</p>
          </div>
        </div>
        <div className="modal-footer">
          <Button type="button" onClick={onCancel} variant="secondary">
            {secText}
          </Button>
          <Button type="button" onClick={onConfirm} variant={variant}>
            {varText}
          </Button>
        </div>
      </div>
    </div>
  );
}
